import { JSX, useEffect } from "react";
import { getLocalValue, saveLocalValue } from "../Logic/storage";
import { iAuth } from "./types";
import { clearSession, parseJwt } from "./TokenManager";
import useInterval from "../hooks/useInterval";

interface props {
    children: JSX.Element[] | JSX.Element | undefined;
}

function Wrapper(props: props) {
    let crypto = getLocalValue<iAuth>("auth");

    useEffect(() => {
        const checkCrypto = async () => {
            var urlParts = window.location.href.substring(window.location.href.indexOf("://") + 3).split("/");
            let redirectURL = "";
            if (urlParts.length > 1 && urlParts[1] != "") {
                redirectURL = "?_referer=" + urlParts[1];
            }
            if (crypto == null) {
                window.location.href = "/auth/callback/" + redirectURL;
            } else if (crypto.code == "") {
                window.location.href = "/auth/callback/" + redirectURL;
            }
        };
        checkCrypto();
        checkToken();
    });

    const checkToken = async () => {
        if (crypto) {
            const idToken = parseJwt(crypto?.token.id_token);
            let expiredDate = new Date(idToken.exp * 1000);
            let currentDate = new Date();
            if (
                expiredDate < currentDate ||
                Math.floor((expiredDate.getTime() - new Date().getTime()) / 1000 / 60) < 10 // means token is about to expire in 10 mins or less
            ) {
                const tokenEndpoint = new URL(crypto.tokenUrl);
                tokenEndpoint.searchParams.append("grant_type", "refresh_token");
                tokenEndpoint.searchParams.append("refresh_token", crypto.token.refresh_token);
                const hHeaders = new Headers();
                hHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                hHeaders.append("Accept", "application/json");
                var fetchOptions: any = {};
                fetchOptions.method = "POST";
                fetchOptions.headers = hHeaders;
                fetchOptions.body = tokenEndpoint.searchParams;
                try {
                    var response = await fetch(crypto.tokenUrl, fetchOptions);
                    if (response.status == 401) {
                        clearSession();
                    }
                    crypto.token = await response.json();
                    saveLocalValue("auth", crypto);
                } catch (err) {
                    clearSession();
                }
            }
        }
    };

    useInterval(checkToken, 1000 * 60 * 7);

    return <>{crypto != null ? props.children : null}</>;
}

export default Wrapper;
